import { developmentConfig } from './env.development';
import { productionConfig } from './env.production';

// Determina la configurazione in base all'ambiente
const getConfig = () => {
  // Prima controlla se c'è una variabile d'ambiente specifica
  const envMode = process.env.REACT_APP_ENV;
  
  if (envMode === 'production') {
    return productionConfig;
  } else if (envMode === 'development') {
    return developmentConfig;
  }
  
  // Fallback al NODE_ENV standard di React
  if (process.env.NODE_ENV === 'production') {
    return productionConfig;
  } else {
    return developmentConfig;
  }
};

const envConfig = getConfig();

// Configurazione dell'applicazione
export const config = {
  // Configurazione ambiente
  ENV: envConfig.ENV,
  API_URL: process.env.REACT_APP_API_URL || envConfig.API_URL,
  DEBUG: envConfig.DEBUG,
  
  // Timeout per le richieste API
  API_TIMEOUT: envConfig.TIMEOUT,
  API_URL_V1: process.env.REACT_APP_API_URL_V1 || envConfig.API_URL_V1,
  // Headers predefiniti
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Logging
  LOG_LEVEL: envConfig.DEBUG ? 'debug' : 'error',
};

// Log della configurazione attiva (solo in development)
if (config.DEBUG) {
  console.log('🔧 Configurazione attiva:', {
    ENV: config.ENV,
    API_URL: config.API_URL,
    DEBUG: config.DEBUG,
  });
}

export default config; 